import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useListaSiniestro } from './hooks/useListaSiniestro';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dialog } from 'primereact/dialog';
import NuevoCliente from './NuevoCliente';
import NuevoProyecto from './NuevoProyecto';
import NuevoPuesto from './NuevoPuesto';
import ListaFuentes from './ListaFuentes';
import EditaDocumento from './EditaDocumento';
import AdminZonas from './AdminZonas';
import AdminRutas from './AdminRutas';
import AsignaPuestosUsuario from './AsignaPuestosUsuario';
import SiniestroGrupos from './SiniestroGrupos';
import { useState, useRef } from 'react';
import { InputText } from 'primereact/inputtext';

const ListaSiniestro = ({ funcNuevo, funcEdita, esAdmin }) => {
    const {
        footerConfirm,
        toast,
        lstSiniestro,
        visibleConf,
        setVisibleConf,
        siniestro,
        setFechaIni,
        setFechaFin,
        fechaIni,
        fechaFin,
        header,
        actionBody,
        cliente,
        setCliente,
        cargaCliente,
        lstCliente,
        proyecto,
        setProyecto,
        cargaProyecto,
        lstProyecto,
        puesto,
        setPuesto,
        cargaPuesto,
        lstPuesto,
        handleConsulta,
        cargaSiniestros,
        visibleNeoCliente,
        setVisibleNeoCliente,
        setCambioCliente,
        visibleNeoProyecto,
        setVisibleNeoProyecto,
        setCambioProyecto,
        visibleNeoPuesto,
        setVisibleNeoPuesto,
        setCambioPuesto,
        visibleFuente,
        setVisibleFuente,
        visibleDocs,
        setVisibleDocs,
        parCliente,
        setParCliente,
        parProyecto,
        setParProyecto,
        parPuesto,
        setParPuesto,
        visibleZonas,
        setVisibleZonas,
        visibleRutas,
        setVisibleRutas,
        visibleAsignaPuestos,
        setVisibleAsignaPuestos,
        visibleGrupos,
        setVisibleGrupos
    } = useListaSiniestro(funcNuevo, funcEdita, esAdmin);

    const verNuevoCliente = () => {
        setParCliente({});
        setVisibleNeoCliente(true);
    };

    const verEditaCliente = () => {
        setParCliente(cliente);
        setVisibleNeoCliente(true);
    };

    const salirNeoCliente = () => {
        setVisibleNeoCliente(false);
        setCambioCliente((prev) => !prev);
    };

    const verNuevoProyecto = () => {
        //console.log ('KKK CLIENTE : ', cliente)
        if (!cliente?.configuracionDetId) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe Seleccionar un Cliente.'
            });
            return;
        }
        setParProyecto({});
        setVisibleNeoProyecto(true);
    };

    const verEditarProyecto = () => {
        if (!cliente?.configuracionDetId) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe Seleccionar un Cliente.'
            });
            return;
        }
        setParProyecto(proyecto);
        setVisibleNeoProyecto(true);
    };

    const salirNeoProyecto = () => {
        setVisibleNeoProyecto(false);
        setCambioProyecto((prev) => !prev);
    };

    const verNuevoPuesto = () => {
        if (!proyecto?.configuracionDetId) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe Seleccionar un Proyecto.'
            });
            return;
        }
        setParPuesto({});
        setVisibleNeoPuesto(true);
    };

    const verEditarPuesto = () => {
        if (!proyecto?.configuracionDetId) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe Seleccionar un Proyecto.'
            });
            return;
        }
        setParPuesto(puesto);
        setVisibleNeoPuesto(true);
    };

    const salirNeoPuesto = () => {
        setCambioPuesto((prev) => !prev);
        setVisibleNeoPuesto(false);
    };

    const salirDoc = () => {
        setVisibleDocs(false);
    };

    //tipoSiniestroNombre, descripcion, usuarioCrea
    const [filtros, setFiltros] = useState({
        global: { value: null, matchMode: 'contains' },
        tipoSiniestroNombre: { value: null, matchMode: 'contains' },
        descripcion: { value: null, matchMode: 'contains' },
        usuarioCrea: { value: null, matchMode: 'contains' }
    });
    // Estado para los valores visuales de los filtros
    const [valoresFiltros, setValoresFiltros] = useState({
        tipoSiniestroNombre: '',
        descripcion: '',
        usuarioCrea: '',
        global: ''
    });

    const debounceTimer = useRef(null);

    const textoFilterTemplate = (options, field) => {
        return (
            <InputText
                value={valoresFiltros[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    // Actualizamos el valor visual
                    setValoresFiltros((prev) => ({ ...prev, [field]: nuevoValor }));

                    if (debounceTimer.current) {
                        clearTimeout(debounceTimer.current);
                    }
                    
                    // Actualizamos el filtro real con un debounce de 400ms
                    debounceTimer.current = setTimeout(() => {
                        const newFilters = { ...filtros };
                        newFilters[field].value = nuevoValor;
                        setFiltros(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 400);
                }}
                placeholder={`Filtro ${field}`}
                className="w-full"
            />
        );
    };

    return (
        <div className="surface-card p-5 shadow-3 border-round-xl text-800">
            <div className="flex justify-content-between align-items-center border-bottom-1 surface-border pb-3 mb-4">
               {header ? header : <h2 className="m-0 text-primary font-medium"><i className="pi pi-shield mr-2 text-2xl"></i> Listado de Eventos</h2>}
            </div>
            <Toast ref={toast} />
            <ConfirmDialog
                visible={visibleConf}
                onHide={() => setVisibleConf(false)}
                message="Confirma Anular el Evento..?"
                header="Anula Evento"
                icon="pi pi-exclamation-triangle"
                footer={footerConfirm}
            />
            <Dialog
                header={parCliente?.nombre ? 'Editar Cliente' : 'Crear Cliente'}
                visible={visibleNeoCliente}
                onHide={() => setVisibleNeoCliente(false)}
                style={{ width: '50vw' }}
            >
                <NuevoCliente funcSalir={salirNeoCliente} datCliente={parCliente} />
            </Dialog>
            <Dialog
                header={parProyecto?.nombre ? 'Editar Proyecto' : 'Crear Proyecto'}
                visible={visibleNeoProyecto}
                onHide={() => setVisibleNeoProyecto(false)}
                style={{ width: '50vw' }}
            >
                <NuevoProyecto
                    toast={toast}
                    clienteDat={cliente}
                    funcSalir={salirNeoProyecto}
                    datProyecto={parProyecto}
                />
            </Dialog>
            <Dialog
                header={parPuesto?.nombre ? 'Editar Puesto' : 'Crear Puesto'}
                visible={visibleNeoPuesto}
                onHide={() => setVisibleNeoPuesto(false)}
                style={{ width: '50vw' }}
            >
                <NuevoPuesto
                    toast={toast}
                    clienteDat={cliente}
                    proyectoDat={proyecto}
                    funcSalir={salirNeoPuesto}
                    puestoDat={parPuesto}
                />
            </Dialog>
            <Dialog
                header="Lista de Fuentes"
                visible={visibleFuente}
                onHide={() => setVisibleFuente(false)}
                style={{ width: '60vw' }}
            >
                <ListaFuentes datosSin={siniestro} />
            </Dialog>
            <Dialog
                visible={visibleDocs}
                onHide={() => setVisibleDocs(false)}
                header="Editar Documento"
                style={{ width: '60vw' }}
            >
                <EditaDocumento datosSiniestro={siniestro} toast={toast} funcSalir={salirDoc} />
            </Dialog>
            <Dialog visible={visibleZonas} onHide={() => setVisibleZonas(false)} header="Administrados Zonas">
                <AdminZonas />
            </Dialog>
            <Dialog visible={visibleRutas} onHide={() => setVisibleRutas(false)} header="Administrados Rutas">
                <AdminRutas />
            </Dialog>
            <Dialog
                visible={visibleAsignaPuestos}
                onHide={() => setVisibleAsignaPuestos(false)}
                header="Asignar Puestos a Usuarios"
                style={{ width: '70vw' }}
                breakpoints={{ '960px': '90vw' }}
            >
                <AsignaPuestosUsuario funcSalir={() => setVisibleAsignaPuestos(false)} toast={toast} />
            </Dialog>
            <Dialog
                visible={visibleGrupos}
                onHide={() => setVisibleGrupos(false)}
                header="Grupos de Usuarios"
                style={{ width: '80vw' }}
                breakpoints={{ '960px': '95vw' }}
            >
                <SiniestroGrupos funcVolver={() => setVisibleGrupos(false)} />
            </Dialog>
            <div className="surface-50 p-4 border-round-lg shadow-1 border-1 border-200 formgrid grid p-fluid mb-4 align-items-end">
                <div className="col-12 mb-3">
                    <span className="text-secondary font-semibold"><i className="pi pi-filter mr-2"></i>Filtros de Búsqueda</span>
                </div>
                {/*  Cliente */}
                {esAdmin && (
                    <div className="field col-12 md:col-4">
                        <label htmlFor="cboCliente">Cliente:</label>
                        <div className="formgrid grid p-fluid mb-3">
                            <div className="field col-12 md:col-8">
                                {cargaCliente ? (
                                    <div className="flex align-items-center">
                                        <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                                    </div>
                                ) : (
                                    <Dropdown
                                        inputId="cboCliente"
                                        options={lstCliente}
                                        value={cliente}
                                        onChange={(evt) => setCliente(evt.value)}
                                        optionLabel="nombre"
                                        placeholder="Selecciona un Cliente"
                                        showClear
                                        filter
                                    />
                                )}
                            </div>
                            <div className="field col-12 md:col-2">
                                <Button icon="pi pi-plus" tooltip="Nuevo Cliente" onClick={verNuevoCliente} />
                            </div>
                            <div className="field col-12 md:col-2">
                                <Button
                                    icon="pi pi-pencil"
                                    tooltip="Editar Cliente"
                                    onClick={verEditaCliente}
                                    disabled={!cliente?.configuracionDetId}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/*  Proyecto */}
                {esAdmin && (
                    <div className="field col-12 md:col-4">
                        <label htmlFor="cboProyecto">Proyecto:</label>
                        <div className="formgrid grid p-fluid mb-3">
                            <div className="field col-12 md:col-8">
                                {cargaProyecto ? (
                                    <div className="flex align-items-center">
                                        <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                                    </div>
                                ) : (
                                    <Dropdown
                                        options={lstProyecto}
                                        value={proyecto}
                                        optionLabel="nombre"
                                        onChange={(evt) => setProyecto(evt.value)}
                                        inputId="cboProyecto"
                                        placeholder="Selecciona un Proyecto"
                                        showClear
                                        filter
                                    />
                                )}
                            </div>
                            <div className="field col-12 md:col-2">
                                <Button icon="pi pi-plus" tooltip="Nuevo Proyecto" onClick={verNuevoProyecto} />
                            </div>
                            <div className="field col-12 md:col-2">
                                <Button
                                    icon="pi pi-pencil"
                                    tooltip="Editar Proyecto"
                                    onClick={verEditarProyecto}
                                    disabled={!proyecto?.configuracionDetId}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/*  Puesto */}
                {esAdmin && (
                    <div className="field col-12 md:col-4">
                        <label htmlFor="cboPuesto">Puesto:</label>
                        <div className="formgrid grid p-fluid mb-3">
                            <div className="field col-12 md:col-8">
                                {cargaPuesto ? (
                                    <div className="flex align-items-center">
                                        <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                                    </div>
                                ) : (
                                    <Dropdown
                                        options={lstPuesto}
                                        value={puesto}
                                        onChange={(evt) => setPuesto(evt.value)}
                                        optionLabel="nombre"
                                        inputId="cboPuesto"
                                        placeholder="Selecciona un Puesto"
                                        showClear
                                        filter
                                    />
                                )}
                            </div>
                            <div className="field col-12 md:col-2">
                                <Button icon="pi pi-plus" tooltip="Nuevo Puesto" onClick={verNuevoPuesto} />
                            </div>
                            <div className="field col-12 md:col-2">
                                <Button
                                    icon="pi pi-pencil"
                                    tooltip="Editar Puesto"
                                    disabled={!puesto?.configuracionDetId}
                                    onClick={verEditarPuesto}
                                />
                            </div>
                        </div>
                    </div>
                )}

                <div className="field col-12 md:col-4">
                    <label htmlFor="cboPuesto">Fecha Inicial:</label>
                    <Calendar
                        value={fechaIni}
                        onChange={(evt) => setFechaIni(evt.value)}
                        maxDate={fechaFin}
                        dateFormat="dd/mm/yy"
                        showIcon
                    />
                </div>
                <div className="field col-12 md:col-4">
                    <label htmlFor="cboPuesto">Fecha Final :</label>
                    <Calendar
                        value={fechaFin}
                        onChange={(evt) => setFechaFin(evt.value)}
                        minDate={fechaIni}
                        maxDate={new Date()}
                        dateFormat="dd/mm/yy"
                        showIcon
                    />
                </div>
                <div className="field col-12 md:col-4">
                    <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                    <Button label="Consultar" icon="pi pi-search" onClick={handleConsulta} className="p-button-outlined" />
                </div>
            </div>
            
            <div className="formgrid grid p-fluid">
                <div className="field col-12 md:col-12">
                    <DataTable
                        header={<div className="font-medium text-lg pb-2"><i className="pi pi-table mr-2"></i>Eventos Registrados</div>}
                        value={lstSiniestro}
                        showGridlines
                        size="small"
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 15, 25]}
                        responsiveLayout="scroll"
                        loading={cargaSiniestros}
                        emptyMessage={
                            <div className="flex flex-column align-items-center justify-content-center p-5 text-center">
                                <i className="pi pi-search text-400 mb-3" style={{ fontSize: '3rem' }}></i>
                                <strong className="text-700 text-lg">No se encontraron resultados</strong>
                                <p className="text-500 mt-2">Ajusta los filtros de arriba para ver eventos o crea uno nuevo.</p>
                            </div>
                        }
                        loadingIcon="pi pi-spin pi-cog"
                        filters={filtros}
                        filterDisplay="row"
                    >
                        <Column header="Fecha Hora" field="fechaSiniestro" style={{ width: '10%' }}></Column>
                        <Column
                            header="Tipo Evento"
                            field="tipoSiniestroNombre"
                            filter
                            filterPlaceholder="Filtro TipoEvento"
                            filterElement={(options) => textoFilterTemplate(options, 'tipoSiniestroNombre')}
                            style={{ width: '20%' }}
                        ></Column>
                        <Column
                            header="Descripcion"
                            field="descripcion"
                            filter
                            filterPlaceholder="Filtro Descripcion"
                            filterElement={(options) => textoFilterTemplate(options, 'descripcion')}
                            style={{ width: esAdmin ? '35%' : '50%' }}
                        ></Column>
                        {esAdmin && (
                            <Column
                                header="Usuario"
                                field="usuarioCrea"
                                filter
                                filterPlaceholder="Filtro Usuario"
                                filterElement={(options) => textoFilterTemplate(options, 'usuarioCrea')}
                                style={{ width: '20%' }}
                                showFilterMenu={false}
                            />
                        )}
                        <Column header="Acciones" body={actionBody} style={{ width: '15%' }}></Column>
                    </DataTable>
                </div>
            </div>
        </div>
    );
};

export default ListaSiniestro;
